import React, { useEffect, useRef, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { InputField, SelectField } from "../components/FormItems/FormItems";
import { Button } from "../components/Button/Button";
import ResumeSection from "../components/ResumeSection/ResumeSection";
import axios from "axios";
import { apiToken, baseUrl } from "../utils/base_url";

const JobDetailsTop = ({ positionName, positionType = [], positionStatus }) => {
  return (
    <>
      <div
        className="row p-md-4 px-md-5 p-3 "
        style={{
          background:
            "linear-gradient(90deg, rgb(16, 15, 40) 0%, 14.6675%, rgb(30, 29, 90) 29.3349%, 33.7886%, rgb(40, 39, 120) 38.2423%, 44.0024%, rgb(50, 48, 156) 49.7625%, 55.7007%, rgb(59, 68, 203) 61.639%, 70.3682%, rgb(58, 84, 222) 79.0974%, 82.8979%, rgb(54, 99, 233) 86.6983%, 93.3492%, rgb(41, 141, 244) 100%)",
        }}
      >
        <div className="col-12 px-md-5 px-2">
          <div className="d-flex flex-column gap-3 px-md-5 ">
            <span className="text-white fs-5 fw-semibold">
              CAREERS AT ASK FIDES
            </span>
            <div className="d-flex align-items-center gap-2">
              {positionType?.map(
                (type, idx) =>
                  type?.slug !== "all-positions" && (
                    <span key={idx} className="text-white fs-5 fw-semibold">
                      {type?.name}
                      {idx !== positionType?.length - 1 && ","}
                    </span>
                  )
              )}
            </div>

            <h1 className="text-white display-4 fw-bolder">{positionName}</h1>

            <span className="text-white fs14 fw-semibold">
              POSITION STATUS: {positionStatus?.toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const JobDetailsInfo = ({ data, sidebars }) => {
  //  Try Code
  const [currentSection, setCurrentSection] = useState("");
  const sectionsRef = useRef([]);
  const navLinksRef = useRef([]);

  useEffect(() => {
    const sections = document.querySelectorAll(".tab");
    const navLinks = document.querySelectorAll(".jobdetails-sidebar a");

    sectionsRef.current = sections;
    navLinksRef.current = navLinks;

    const handleScroll = () => {
      let current = "";
      const scrollPosition = window.scrollY; // Use window.scrollY for scrolling

      sectionsRef.current.forEach((section) => {
        const sectionTop = section.offsetTop - 100; // Adjust as needed
        const sectionHeight = section.clientHeight;

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          current = section.getAttribute("id");
        }
      });

      navLinksRef.current.forEach((link) => {
        link.classList.remove("job-details-active-tab");
        if (link.getAttribute("href").slice(1) === current) {
          link.classList.add("job-details-active-tab");
        }
      });

      setCurrentSection(current);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentSection]);
  // End Try Code

  return (
    <>
      <div className="row p-md-5 pt-4" style={{ background: "#090D24" }}>
        <div className="col-md-3 px-4 jobdetails-sidebar job-details-tab-section">
          <div className="d-flex flex-column ">
            {sidebars?.map((sidebarData, idx) => (
              <a
                key={idx}
                className=" text-decoration-none text-white fw-bolder fs-6 bg-transparent px-4 py-3"
                href={`#${sidebarData?.slug}`}
              >
                {sidebarData?.title}
              </a>
            ))}
          </div>
        </div>
        <div className="col-md-8 ">
          {data?.long_description?.map((descriptionData, idx) => (
            <div
              key={idx}
              id={descriptionData?.slug}
              className="d-flex flex-column gap-5 p-md-5 p-3 mt-1 tab"
              style={{ background: "#131e2c", border: "1px solid #1e2a68" }}
            >
              <span className="text-white display-5 fw-bold">
                {descriptionData?.heading}
              </span>

              <div className="d-flex flex-column gap-3">
                <div
                  className="text-white fs-6"
                  dangerouslySetInnerHTML={{
                    __html: descriptionData?.text,
                  }}
                />
              </div>
            </div>
          ))}
          <ResumeSection id={"resume"} />
          <ApplySection id={"apply"} />
        </div>
      </div>
    </>
  );
};

const ApplySection = ({ id }) => {
  return (
    <>
      <div
        className=" d-flex align-items-center justify-content-center flex-column mt-1 p-md-5 p-3  gap-5 mb-5"
        style={{ background: "#131e2c", border: "1px solid #1e2a68" }}
        id={id}
      >
        <span className="display-5 text-white">Apply</span>

        <form>
          <div className="row w-100 px-md-5 ps-3 gy-4">
            <InputField
              className={`col-12`}
              label={"Your Email"}
              placeholder={"Enter your work email"}
            />
            <InputField
              className={`col-md-6`}
              label={"First Name"}
              placeholder={"First name"}
            />
            <InputField
              className={`col-md-6`}
              label={"Last Name"}
              placeholder={"Last name"}
            />
            <InputField
              className={`col-12`}
              label={"Your Current Employer/Company Name"}
              placeholder={"Enter your company name"}
            />
            <SelectField
              className={`col-12`}
              label={"Please Select Your Qualification Level"}
              placeholder={"Select"}
            />
            <InputField
              className={`col-12`}
              label={"Please provide LinkedIn profile link"}
              placeholder={"Enter your LinkedIn profile url here"}
            />

            <div className="col-12">
              <Button
                className={"px-5 py-1"}
                background="#0039EC"
                textColor={"white"}
              >
                Register & Apply
              </Button>
            </div>

            <div className="col-12">
              <span className="fs-6 " style={{ color: "#90A3BE" }}>
                By submitting this form you agree to the terms and conditions of
                Ask Fides
              </span>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const JobDetails = () => {
  const [jobDetailData, setJobDetailData] = useState(
    JSON.parse(localStorage.getItem("positionData")) || {}
  );

  const [loader, setLoader] = useState(false);
  const [sidebar, setSidebar] = useState();

  useEffect(() => {
    setLoader(true);
    const fecthSidebars = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/position-sidebars`, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        });
        console.log(res?.data?.data);
        setSidebar(res?.data?.data);
        setLoader(false);
      } catch (error) {
        console.log(error);
      }
    };

    if (Object.keys(jobDetailData).length <= 0) {
      setLoader(true);
    } else {
      fecthSidebars();
    }
  }, [jobDetailData, setSidebar]);
  return (
    <>
      <MainLayout loader={loader}>
        <div className="container-fluid   ">
          <JobDetailsTop
            positionName={jobDetailData?.title}
            positionType={jobDetailData?.career_departments}
            positionStatus={jobDetailData?.position_status}
          />

          <JobDetailsInfo data={jobDetailData} sidebars={sidebar} />
        </div>
      </MainLayout>
    </>
  );
};

export default JobDetails;
